import React from 'react';
import { Link } from 'react-router-dom';

interface VerificationNoticeProps {
  hasVerifiedSnippet: boolean;
}

const VerificationNotice: React.FC<VerificationNoticeProps> = ({ hasVerifiedSnippet }) => {
  if (hasVerifiedSnippet) {
    return null;
  }

  return (
    <div className="alert alert-warning alert-dismissible fade show" role="alert">
      <div className="d-flex align-items-center">
        <i className="fas fa-exclamation-triangle me-3 fs-4"></i>
        <div className="flex-grow-1">
          <h5 className="alert-heading mb-1">Website Verification Required</h5>
          <p className="mb-2">
            To access analytics, sentiment analysis, and other features, you need to verify at least one website first.
          </p>
          <div className="d-flex gap-2">
            <Link to="/dashboard/snippets" className="btn btn-warning btn-sm">
              <i className="fas fa-globe me-2"></i>
              Manage Websites
            </Link>
            <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationNotice;
